import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { DialogsEnum } from '@/enums'
import ActionTypes from '../constants'
import { SaveWageringCategoryPayload, WageringState } from '../models'

import { WAGERING } from './api.routes'
import { getWCCategoriesThunk } from './get-wc-categories.thunk'

const apiService: RestApiService = Container.get(RestApiService)

export const saveWCCategoryThunk = createAsyncThunk(
  ActionTypes.SAVE_WC_CATEGORY,
  async (payload: SaveWageringCategoryPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: WAGERING.WC_CATEGORY_SAVE,
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await apiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('wageringContribution')}`,
        what: i18n.t('labels.updated'),
      })

      if (response.statusCode && response.statusCode !== 200) {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(getWCCategoriesThunk())
        thunkAPI.dispatch(
          setDialogAction({
            open: false,
            id: DialogsEnum.DIALOG_WAGERING_CONTRIBUTION_FORM,
          }),
        )
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.statusCode && response.statusCode !== 200
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const saveWCCategoryExtraReducer = (
  builder: ActionReducerMapBuilder<WageringState>,
) => {
  builder.addCase(saveWCCategoryThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(saveWCCategoryThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
  })
}

export default saveWCCategoryExtraReducer
